import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const CustomToolTip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    PopperProps={{
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, props.offset || 2],
          },
        },
      ],
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: '#737373',
    fontSize: '12px',
    alignItems: 'center',
    boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    padding: '4px 10px',
  },
}));
